import { Rgb } from './Rgb.js';

export type Status = readonly [
  coloredLabelText: readonly [text: string, ...args: ReadonlyArray<string>],
  messageColor: Rgb | null
];

export function Status(
  labelText: string,
  labelTextColor: Rgb,
  labelBackgroundColor: Rgb,
  messageColor: Rgb | null
): Status {
  return [
    [
      `%c ${labelText} %c`,
      `color: rgb(${labelTextColor.join(' ')}); background: rgb(${labelBackgroundColor.join(' ')}); font-weight: bold;`,
      ''
    ],
    messageColor
  ];
}

export namespace Status {
  export const success = Status(
    '✓',
    Rgb.white,
    Rgb.Status.success,
    Rgb.Status.success
  );

  export const info = Status('ℹ', Rgb.black, Rgb.white, null);

  export const warning = Status(
    '‼',
    Rgb.black,
    Rgb.Status.warning,
    Rgb.Status.warning
  );

  export const error = Status(
    '✕',
    Rgb.white,
    Rgb.Status.error,
    Rgb.Status.error
  );

  export const verbose = Status(
    'ꙮ',
    Rgb.Status.verboseLabelText,
    Rgb.Status.verbose,
    Rgb.Status.verbose
  );
}
